package com.mrpowergamerbr.puppydough.webrune

import web.file.File

sealed class UIState {
    data class Ready(val version: WebruneConfig.GameVersion) : UIState()
    data object UploadGame : UIState()
    data class DetectedGame(val gameWADFile: File, val files: List<File>, val hash: String) : UIState()
    data class ProcessingGame(val filename: String, val count: Int, val total: Int) : UIState()
    data object SelectGameVersion : UIState()
}